export default __webpack_public_path__ + "static/media/american-express.7756b6ad.svg";